/**
 * Preuves terrain — carrousel (brief "Test 2", 2026-08-06 — refonte
 * complete). BROUILLON, pas publie/deploye tant que non valide par le
 * proprietaire de la marque.
 *
 * Vs la version precedente ("Focus Test", mobile uniquement) :
 * - actif a TOUTES les tailles (mobile/tablette/desktop), plus seulement
 *   <=640px ;
 * - le nombre de cartes visibles simultanement est calcule depuis la
 *   geometrie REELLE du DOM (largeur de la 1re slide + gap du track),
 *   jamais suppose ou code en dur (1 sur mobile, 2 sur tablette, 4 sur
 *   desktop selon assets/base.css, mais le JS ne connait pas ces chiffres
 *   a l'avance : il les mesure) ;
 * - navigation par "index de depart" (startIndex = index de la 1re carte
 *   visible), deplacement d'une carte a la fois, jamais au-dela de
 *   total - visibleCount (pas d'espace vide apres la derniere carte) ;
 * - viewport.scrollTo({left}) plutot que scrollIntoView, pour ne jamais
 *   risquer un scroll vertical de la page ;
 * - la classe modificatrice est desormais "is-scrollable" (total > nombre
 *   visible AU BREAKPOINT COURANT), recalculee au resize — remplace
 *   l'ancienne "is-single" qui ne regardait que "total <= 1".
 *
 * 2026-08-06 (ter) : demande explicite —
 * - fleches remontees au niveau des photos : ce sont desormais des enfants
 *   directs de .preuves-terrain__carousel (pas de .preuves-terrain__viewport,
 *   qui a overflow-y:hidden et les rognerait), positionnees en absolu et
 *   centrees verticalement sur la 1re photo via positionArrows() ci-dessous
 *   (mesure reelle du DOM, pas de valeur en dur — les cartes n'ont pas
 *   toutes la meme hauteur selon le contenu/la phase) ;
 * - retour a des points de pagination sous les cartes (au lieu de la piste
 *   de progression testee juste avant), mais SANS compteur chiffre
 *   ("1-4/9") — les points suffisent comme repere de position sans
 *   exposer le total. 1 point par carte reellement rendue, genere par JS.
 */
(function () {
  "use strict";

  var instances = new WeakMap(); // root -> { teardown }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function initCarousel(root) {
    if (instances.has(root)) return; // deja initialise, evite les doubles listeners

    var viewport = root.querySelector("[data-preuves-carousel-viewport]");
    var track = root.querySelector("[data-preuves-carousel-track]");
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll("[data-preuves-carousel-slide]")) : [];
    var paginationEl = root.querySelector("[data-preuves-carousel-pagination]");
    var prevBtn = root.querySelector("[data-preuves-carousel-prev]");
    var nextBtn = root.querySelector("[data-preuves-carousel-next]");

    if (!viewport || !track || slides.length === 0) return;

    var controller = new AbortController();
    var signal = controller.signal;
    var total = slides.length;
    var startIndex = 0;
    var visibleCount = 1;
    var dots = [];

    // --- Geometrie reelle : combien de slides tiennent dans le viewport ---
    function computeVisibleCount() {
      var viewportWidth = viewport.clientWidth;
      var slideWidth = slides[0].getBoundingClientRect().width;
      if (!slideWidth) return 1;
      var trackStyle = window.getComputedStyle(track);
      var gap = parseFloat(trackStyle.columnGap || trackStyle.gap || "0") || 0;
      var count = Math.floor((viewportWidth + gap + 0.5) / (slideWidth + gap));
      return Math.max(1, Math.min(count, total));
    }

    function maxStartIndex() {
      return Math.max(0, total - visibleCount);
    }

    function clampStart(i) {
      return Math.max(0, Math.min(maxStartIndex(), i));
    }

    function updateScrollableState() {
      visibleCount = computeVisibleCount();
      var scrollable = total > visibleCount;
      root.classList.toggle("is-scrollable", scrollable);
      return scrollable;
    }

    // --- Fleches : centrees verticalement sur la 1re photo (mesure reelle,
    // pas de hauteur supposee : le contenu/la phase font varier la hauteur
    // totale de la carte mais pas celle de la photo, carree). ---------------
    function positionArrows() {
      if (!prevBtn && !nextBtn) return;
      var photoWrap = slides[0].querySelector(".preuves-terrain__photo-wrap");
      if (!photoWrap) return;
      var rootRect = root.getBoundingClientRect();
      var photoRect = photoWrap.getBoundingClientRect();
      var centerY = photoRect.top - rootRect.top + photoRect.height / 2;
      if (prevBtn) prevBtn.style.top = centerY + "px";
      if (nextBtn) nextBtn.style.top = centerY + "px";
    }

    // --- Pagination (1 point par slide reellement rendue, jamais un total en dur) ---
    if (paginationEl) {
      paginationEl.textContent = "";
      slides.forEach(function (_slide, i) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "preuves-terrain__dot";
        dot.setAttribute("aria-label", "Afficher l'avis " + (i + 1) + " sur " + total);
        var visual = document.createElement("span");
        visual.setAttribute("aria-hidden", "true");
        dot.appendChild(visual);
        dot.addEventListener("click", function () { goTo(i); }, { signal: signal });
        paginationEl.appendChild(dot);
        dots.push(dot);
      });
    }

    function updateUI(index) {
      startIndex = index;
      dots.forEach(function (dot, i) {
        dot.setAttribute("aria-current", i === index ? "true" : "false");
      });
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxStartIndex();
    }

    // --- Navigation : viewport.scrollTo() calcule depuis le viewport,
    // jamais scrollIntoView (risque de scroll vertical de la page). -------
    function goTo(index) {
      var clamped = clampStart(index);
      var target = slides[clamped];
      if (!target) return;
      viewport.scrollTo({
        left: target.offsetLeft,
        behavior: prefersReducedMotion() ? "auto" : "smooth",
      });
      updateUI(clamped);
    }

    // --- Synchronisation avec le defilement tactile/trackpad --------------
    var ticking = false;
    function syncFromScroll() {
      var scrollLeft = viewport.scrollLeft;
      var closest = 0;
      var closestDistance = Infinity;
      slides.forEach(function (slide, i) {
        var distance = Math.abs(slide.offsetLeft - scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = i;
        }
      });
      var clamped = clampStart(closest);
      if (clamped !== startIndex) updateUI(clamped);
    }
    viewport.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(function () {
            syncFromScroll();
            ticking = false;
          });
        }
      },
      { passive: true, signal: signal }
    );

    // --- Fleches : deplacent d'exactement 1 carte --------------------------
    if (prevBtn) {
      prevBtn.addEventListener("click", function () { goTo(startIndex - 1); }, { signal: signal });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () { goTo(startIndex + 1); }, { signal: signal });
    }

    // --- Redimensionnement / changement d'orientation / changement de
    // breakpoint : recalcule le nombre visible, garde la slide de depart
    // la plus proche (clampee au nouveau maximum), recale sans animation,
    // et repositionne les fleches (la hauteur de la photo change avec la
    // largeur de carte). ----------------------------------------------------
    var resizeTimer = null;
    function handleResize() {
      updateScrollableState();
      var clamped = clampStart(startIndex);
      var target = slides[clamped];
      if (target) viewport.scrollTo({ left: target.offsetLeft, behavior: "auto" });
      updateUI(clamped);
      positionArrows();
    }
    window.addEventListener(
      "resize",
      function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(handleResize, 150);
      },
      { signal: signal }
    );

    updateScrollableState();
    updateUI(0);
    positionArrows();
    root.classList.add("is-ready");

    instances.set(root, {
      teardown: function () {
        controller.abort();
        root.classList.remove("is-ready", "is-scrollable");
      },
    });
  }

  function teardownCarousel(root) {
    var instance = instances.get(root);
    if (!instance) return;
    instance.teardown();
    instances.delete(root);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll("[data-preuves-carousel]");
    Array.prototype.forEach.call(roots, initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // --- Compatibilite editeur Shopify ---------------------------------------
  document.addEventListener("shopify:section:load", function (event) {
    var roots = event.target.querySelectorAll
      ? event.target.querySelectorAll("[data-preuves-carousel]")
      : [];
    Array.prototype.forEach.call(roots, function (root) {
      teardownCarousel(root);
      initCarousel(root);
    });
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var roots = event.target.querySelectorAll
      ? event.target.querySelectorAll("[data-preuves-carousel]")
      : [];
    Array.prototype.forEach.call(roots, teardownCarousel);
  });
})();
